module.exports = __webpack_public_path__ + "static/media/logoFooter.8f4f50ec.svg";